import React, { useState, useEffect, useRef } from 'react';
import { Container, Form, Row, Col, Button } from '@themesberg/react-bootstrap';
import ListTables from '../../shared/tables';
import { get, post } from '../../../services/back.service';

function FormAccesories({ id }) {
  const brandRef = useRef('');
  const valueRef = useRef(0);
  const quantityRef = useRef(0);
  const accesoryRef = useRef('');
  const [accesories, setaccesories] = useState([]);
  const [msgButton, setMsgButton] = useState('Guardar Informacion')
  const [listAccesories, setListAccesories] = useState([])

  // const handleForm = ({ target }) => {
  //   const value = target.type === 'checkbox' ? target.checked : target.value;
  //   setInfoResult({ ...accesories, [target.name]: value });
  //   //generalUpdate(target.name, value);
  // };
  const saveForm = (e) => {
    e.preventDefault();
    const selectedText = accesoryRef.current.options[accesoryRef.current.selectedIndex].text;
    const accesory = accesoryRef.current.value;
    const brand = brandRef.current.value;
    const value = valueRef.current.value;
    const quantity = quantityRef.current.value;
    accesories.push({
      id_accesory: accesory,
      accesory: selectedText,
      brand,
      value,
      quantity,
    });
    setaccesories([...accesories]);
    accesoryRef.current.value = '';
    brandRef.current.value = '';
    valueRef.current.value = '';
    quantityRef.current.value = '';
  };

  const deleteItem = (idx) => {
    accesories.splice(idx, 1);
    setaccesories([...accesories]);
  };

  const deleteButton = (row) => {
    const idx = accesories.findIndex((e) => e.index === row.index)
    return (
      <Button
        title="Eliminar"
        text="Eliminar"
        variant="outline-danger"
        onClick={() => deleteItem(idx)}
      >Eliminar</Button>
    );
  };
  const sendInfo = async (event) => {
    event.preventDefault();
    const body = {
      data: accesories
    };
    const respo = await post('/peritaje/modifyinspection/accesories/' + id, body);
    if (respo.success) {
      setMsgButton('Actualizar')
    }
  };

  useEffect(() => {
    const getInfo = async () => {
      const respo = await get('/peritaje/accesories/', {});
      if (respo.success) {
        setListAccesories(respo.data)
      }
    }
    getInfo()
  }, [])

  useEffect(() => {
    const initForm = async () => {
      const body = {};
      const respo = await post(
        '/peritaje/infodetailinspection/accesories/' + id,
        body,
      );
      if (respo.success) {
        const { detail } = respo.data;
        setaccesories(detail);
      }
    };
    initForm();
  }, [id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">ACCESORIOS</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form onSubmit={(e) => saveForm(e)}>
            <Form.Label htmlFor="currentType">Accesorio</Form.Label>
            <Form.Select
              name="currentType"
              ref={accesoryRef}
              aria-label="Default select example"
            >
              <option value="">Seleccione</option>
              {listAccesories.map((element, i) => {
                const isAvailable = !accesories.find(acc => acc.accesories === element.name);
                if (isAvailable) {
                  return <option key={i} value={element.id}>{element.name}</option>;
                }
                return null;
              })}
            </Form.Select>
            <Form.Label htmlFor="solicitante">Marca</Form.Label>
            <Form.Control
              type="text"
              ref={brandRef}
              required
            />
            <Form.Label htmlFor="solicitante">Cantidad</Form.Label>
            <Form.Control
              type="number"
              ref={quantityRef}
              required
            />
            <Form.Label htmlFor="solicitante">Valor</Form.Label>
            <Form.Control
              type="number"
              ref={valueRef}
              required
            />

            <Row className="my-3">
              <Col className="d-flex justify-content-end">
                <Button
                  disabled={!(accesories.length < 7)}
                  type="submit"
                  variant="primary"
                >
                  Agregar Accesorio
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col>
          <ListTables
            data={accesories}
            editar={deleteButton}
            messageWd={'Agrege un siniestro'}
            hideFirst={true}
          />
        </Col>
      </Row>
      <Row className="my-3">
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo}>
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormAccesories;
